module.exports = __webpack_public_path__ + "7777cd716bf97d16bd4e679fa6b50fc4.png";